export class TextovyModalniPanelData {
	nadpis: string;
	text: string;
	popisekTlacitkaAkce: string;
}
